import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Row from "../common/Row";
import classnames from "classnames";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const StofComponent = (props) => {
    const model = props.model;
    const exclamationTriangleStyle = { textAlign: 'right', color: "#FBCC05", fontSize: '20px', float: "right", paddingTop: "12px" };

    return (
        <div key={model.id}>
            <br />
            <div className="kader">
                <Row noSpacing>
                    <h3 className={classnames(["leftMargin", "l-grid__col:10/12"])}>{model.naam}</h3>
                    {model.opmerking ?
                        <Fragment>
                            <div className="l-grid__col:1/12 " />
                            <div>
                                <span
                                    className="c-icon c-code__icon c-icon__yellow"
                                    aria-hidden="true"
                                    focusable="false"
                                ><FontAwesomeIcon style={exclamationTriangleStyle} icon={faExclamationTriangle} />
                                </span>
                            </div>
                        </Fragment> : null}
                </Row>
                {model.tekst ? <p className="leftMargin detailText">{model.tekst}</p> : null}
                {model.tekst ? <br /> : null}
                {model.opmerking ? <h4 className="leftMargin">Opmerking</h4> : null}
                {model.opmerking ? <p className="leftMargin detailText">{model.opmerking}</p> : null}
            </div>
        </div>
    );
};

StofComponent.defaultProps = {

};

StofComponent.propTypes = {
    model: PropTypes.object
};

export default StofComponent;